import { FC } from 'react'

import { useGET_studentsQuery } from 'redux/api/studentsApi'

import PageHeading from 'components/atoms/PageHeading'
import MainTable from 'components/organisms/tables/MainTable'
import TeamEnrollStudentForm from 'components/organisms/forms/TeamEnrollStudentForm'

import { useTableModel } from 'utils/tableModels/useTeamEnrolledStudentsTableModel'

import { useTranslation } from 'react-i18next'
import { ActionType } from 'types'
import { Grid } from '@mui/material'
import { useGET_teamByIdQuery } from 'redux/api/teamsApi'


interface IProps {
    action: ActionType
    id: string
    viewOnly: boolean
    tabText?: string
    tabKey?: string
  }

  
const TeamEnrolledStudents: FC<IProps> = ({ action, id, viewOnly }) => {
  const { t } = useTranslation()
  const filters = { team: id }

  return (
    <>
      <Grid container spacing={4} sx={{ marginTop: '-1rem' }}>
        <Grid item xs={6}>
          <PageHeading title={t('common.students')} />
        </Grid>
        <Grid item xs={6}>
          <TeamEnrollStudentForm id={id} viewOnly={viewOnly} />
        </Grid>
      </Grid>

      <MainTable
        useTableModel={useTableModel}
        getTableData={useGET_studentsQuery}
        tableRowParams={ {team_id: id} }
        filters={filters}
        header={null}
      />
    </>
  )
}
export default TeamEnrolledStudents
